module.exports = __webpack_public_path__ + "dist/assets/img/webcommerce.31607b97.svg";